import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'


const SelectComponent = ({
	control,
	disabled = false,
	label = null,
	name,
	required = true,
	options = [],
	defaultValue = '',
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Controller
					name={name}
					control={control}
					defaultValue={defaultValue}
					rules={{
						required: {
							value: required,
							message: 'Campo obrigatório'
						}
					}}
					render={({ field, fieldState: { error } }) => (
						<>

							<Form.Select
								id={name}
								disabled={disabled}
								className={error ? 'is-invalid' : ''}
								{...field}
								{...rest}
							>
								{options && options.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
							</Form.Select>

							{error && <p className='mt-1 form-error'>{error.message}</p>}

						</>
					)}
				/>

			</Form.Group>

		</>
	)

}

export default SelectComponent;
